import React from 'react';
import classnames from 'classnames';

import MemoryFilesGridItemPreview from './FilesGridItemPreview';

import type { Asset } from '../../types/asset';

interface MemorySprkFilesItemProps {
  asset: Asset;
  isSelected?: boolean;
  handleSelectFile: Function;
};

const MemorySprkFilesItem: React.FC<MemorySprkFilesItemProps> = ({ asset, isSelected, handleSelectFile }) => {
  const selectFile = () => {
    handleSelectFile(asset.id);
  };

  return (
    <div className={classnames('memory-sprk-files-grid-item', { 'memory-sprk-files-grid-item--selected': isSelected })}>
      <label>
        <input type="checkbox" name="select-sprk-file" onChange={selectFile} value={asset.id} checked={isSelected} />
        <MemoryFilesGridItemPreview file={asset} />
      </label>
    </div>
  );
}

export default MemorySprkFilesItem;
